import getters from './getters'
import actions from './actions'
import mutations from './mutations'
const state = {
    bot: null,
    bots: [],
    modelDefault: {
        id: null,
        hash_id: null,
        title: '',
        work_days: 127,
        work_time: null,
        status: 1, // 0 - удален, 1 - включен, 2 - выключен
        platform: 'vk',
        token_tg: null,
        token_vk_mailing: null,
        token_vk: null
    },
    moderators: [],
    modelModeratorDef: {
        id: null,
        moderator_id: null,
        bot_id: null,
        created_at: null,
        deleted: 0
    },
    loadedBots: false,
    botLoaded: false,
    tariffs: []
}
export default {
    state,
    getters,
    actions,
    mutations
}
